import './Divider.scss'
import type { ComponentProps } from 'react'
import { clx } from '../clx'

export interface DividerProps extends Omit<ComponentProps<'hr'>, 'children'> {
  /** Space above and below. Default `md`. */
  spacing?: 'none' | 'sm' | 'md' | 'lg'
}

/** MUI's Divider: a thematic break (`<hr>`, role separator) between sections. */
export function Divider({ spacing = 'md', className, ...rest }: DividerProps) {
  return (
    <hr
      {...rest}
      className={clx('divider', spacing !== 'md' && `divider--is-${spacing}`, className)}
    />
  )
}
